import { ErrorState, LoadingState } from '../../shared/ui/states';
import { useRetentionUsage, useStorageLevels } from '../../entities/retention';
import { NextCleanupCard } from './next-cleanup-card';
import { QuotaCleanupCard } from './quota-cleanup-card';
import { StoredNowCard } from './stored-now-card';

interface IStorageOverviewProps {
  now: number;
  timeZone?: string;
  onBiggest: () => void;
  onDeleteNow: () => void;
}

/** Board S1, top row: how much is stored, and what goes next. */
export const StorageOverview = ({
  now,
  timeZone,
  onBiggest,
  onDeleteNow,
}: IStorageOverviewProps) => {
  const usage = useRetentionUsage();
  const levels = useStorageLevels();

  if (usage.isError) return <ErrorState error={usage.error} onRetry={() => void usage.refetch()} />;
  if (usage.isPending) return <LoadingState rows={6} />;

  const data = usage.data;
  return (
    <div className="grid grid-cols-5 items-start gap-5">
      <div className="col-span-3">
        <StoredNowCard
          usage={data}
          levels={levels.data}
          now={now}
          timeZone={timeZone}
          onBiggest={onBiggest}
        />
      </div>
      <div className="col-span-2">
        {data.lastQuota ? (
          <QuotaCleanupCard run={data.lastQuota} usage={data} now={now} timeZone={timeZone} />
        ) : (
          <NextCleanupCard
            usage={data}
            levels={levels.data}
            now={now}
            onBiggest={onBiggest}
            onDeleteNow={onDeleteNow}
          />
        )}
      </div>
    </div>
  );
};
